// Actions
import { ActionType } from "@ms/planner-actions/lib/local/ActionType";
import { TableName } from "@ms/uno-constants/lib/local/StoreConstants";
// Stores
import { EventPublishingStore } from "@ms/uno-fluxcore/lib/local/stores/EventPublishingStore";
import { Slice } from "../../slice/Slice";
import { compositeKeyFromStringArray } from "@ms/uno-utilities/lib/local/StringUtilities";
import { logUnreachableAction } from "../../utilities/LoggingUtilities";
/**
 * Store containing the access tokens and user id information
 */ export class AuthStore extends EventPublishingStore {
    get name() {
        return "AuthStore";
    }
    handleAction(action) {
        let storeChanged = false;
        switch(action.type){
            case ActionType.FetchAccessTokenAction:
                storeChanged = this.handleFetchAccessTokenAction(action);
                break;
            case ActionType.FetchAccessTokenSucceededAction:
                storeChanged = this.handleFetchAccessTokenSucceededAction(action);
                break;
            case ActionType.FetchAccessTokenFailedAction:
                storeChanged = this.handleFetchAccessTokenFailedAction(action);
                break;
            case ActionType.ClearAccessTokenAction:
                storeChanged = this.handleClearAccessTokenAction(action);
                break;
            default:
                logUnreachableAction(this, this.loggers, action);
                return;
        }
        if (storeChanged) {
            this.publishStoreChangedEvent();
        }
    }
    /**
     * Get the accessToken currently stored for given scopes and claims
     * @param scopes
     * @param claims
     */ getAccessToken(scopes, claims) {
        const tokenId = this.getTokenId(scopes, claims);
        return this.tokenSlice.get(tokenId);
    }
    isAuthPersistentlyFailing() {
        return this.persistentlyFailing;
    }
    getTokenId(scopes, claims) {
        const scopesKey = compositeKeyFromStringArray(scopes);
        return claims ? `${scopesKey}:${claims}` : scopesKey;
    }
    handleFetchAccessTokenAction(action) {
        const tokenId = this.getTokenId(action.scopes, action.claims);
        return this.tokenSlice.handleFetchStarted(tokenId);
    }
    handleFetchAccessTokenSucceededAction(action) {
        // Track auth recovery before token-specific logic
        this.consecutiveAuthFailures = 0;
        let storeChanged = false;
        if (this.persistentlyFailing) {
            this.persistentlyFailing = false;
            storeChanged = true;
        }
        const tokenId = this.getTokenId(action.scopes, action.claims);
        const token = {
            accessToken: action.accessToken,
            expiry: action.expiry
        };
        return this.tokenSlice.handleFetchSucceeded(tokenId, token) || storeChanged;
    }
    handleFetchAccessTokenFailedAction(action) {
        // Track auth failures before token-specific logic
        this.consecutiveAuthFailures++;
        let storeChanged = false;
        if (!this.persistentlyFailing && this.consecutiveAuthFailures >= AuthStore.AUTH_FAILURE_THRESHOLD) {
            this.persistentlyFailing = true;
            storeChanged = true;
        }
        const tokenId = this.getTokenId(action.scopes, action.claims);
        return this.tokenSlice.handleFetchFailed(tokenId, null) || storeChanged;
    }
    handleClearAccessTokenAction(action) {
        const tokenId = this.getTokenId(action.scopes);
        return this.tokenSlice.handleDeleteSucceeded(tokenId);
    }
    constructor(loggers, configProvider){
        super(), this.loggers = loggers, this.configProvider = configProvider, this.tokenSlice = new Slice(TableName.AccessTokens, {
        }, this.configProvider), this.consecutiveAuthFailures = 0, this.persistentlyFailing = false;
    }
}
/** Number of consecutive auth token failures before marking as persistently failing */ AuthStore.AUTH_FAILURE_THRESHOLD = 3;
